// Window.location Functions

export const getQueryParams = (url) => (
    !url && window.location.search
        ? window.location.search
        : `?${(url || window.location.href).split('?')[1] || ''}`)
    .replace(/^\?/, '')
    .split('&')
    .map(str => str.trim()
        .split('=')
        .map(_str => decodeURIComponent(_str)))
    .filter(arr => arr.length > 1)
    .reduce((obj, [key, value]) => {
        if (!obj[key])
            return { ...obj, [key]: value }

        if (Array.isArray(obj[key]))
            obj[key].push(value)

        if (!Array.isArray(obj[key]))
            obj[key] = [obj[key], value]

        return obj
    }, {}) || {}
